import { Button, CircularProgress, Divider, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import FileIcon from '../../providers/FileIcon';
import LocalStorage from '../../providers/LocalStorage';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import WsC from '../chestionare/providers/WsC';
import ChartsMonitorizare from './ChartMonitorizare';
import DoughnutChart from './DoughnutChart';
import PopUpAplicatie from './PopUpAplicatie';
import generic from '../../Pics/iconsMonitorizare/generic.png'
import ClientAppointment from './ClientAppointment';
import DatePicker, { registerLocale, setDefaultLocale, usePopper, popperPlacement } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";

import ro from 'date-fns/locale/ro';
import es from 'date-fns/locale/es'
import { createPopper } from '@popperjs/core';
import EditEticheta from './EditEticheta';


import { ReactComponent as ThumbUp } from './MonitorizareIcons/thumb_up_black.svg';
import { ReactComponent as ThumbDown } from './MonitorizareIcons/thumb_down_black.svg';
import { ReactComponent as SportSoccer } from './MonitorizareIcons/sports_soccer_black.svg';
import { ReactComponent as OpenInNew } from './MonitorizareIcons/open_in_new_black.svg';
import { ReactComponent as HistoryToggle } from './MonitorizareIcons/history_toggle_off_black.svg';
import { ReactComponent as BookmarksBlack } from './MonitorizareIcons/bookmarks_black.svg';

registerLocale('ro', ro)



// const customClass = document.querySelector('.some-custom-class')
// usePopper(customClass);

export default class MonitorizareAngajatNew extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            ani: this.u.getLast10YearsIncludingThisYear(),
            luni: this.u.luni,
            anul: new Date(this.u.defaultData()).getFullYear(),
            luna: new Date(this.u.defaultData()).getMonth(),
            ziua: new Date(this.u.defaultData()).getDate(),
            zile: this.u.getAllDaysInMonth(new Date(this.u.defaultData()).getFullYear(), new Date(this.u.defaultData()).getMonth()),
            dataAzi: this.u.defaultData(),
            dataStart: this.m.fistDayMonth(new Date()),
            dataEnd: this.m.lastDayMonth(new Date()),
            angajati: { nume: '', aplicatii: [], aplicatii_folosite: [], aplicatii_folosite_merged: [], productivity_hourly: [] },
            oreLucru: this.u.oreLucruDefault,
            screenShots: [],
            openPopupAplicatie: false,
            aplicatie: {},
            raportAplicatii: null,
            loading: true,
            alertView: false,
            oreLucruSelectie: [
                { oraStart: '12:00', oraFinish: '13:00' },
                { oraStart: '13:00', oraFinish: '14:00' },
                { oraStart: '14:00', oraFinish: '15:00' },
                { oraStart: '15:00', oraFinish: '16:00' },
                { oraStart: '16:00', oraFinish: '17:00' }
            ],
            oraSelectata: null,
            aplicatiiFolositeIntervalOre: [],
            pauza: {},
            dataStartDistributiaT: new Date(new Date().setDate(new Date().getDate() - 1)),
            dataEndDistributiaT: new Date(),
            angajatiMonth: { aplicatii_folosite_principale: [], etichete: [] },
            pauzaInterval: {},
            aplicatiiFolositeIntervalOreDetails: [],
            openEticheta: false,
            aplicatieSelectata: {},
            oraSelectataApp: {}

        }
    }

    componentDidMount() {
        this.access()
        this.getData()
        this.getDataMonth()
        // this.u.getAllDaysInMonth(2021, 7)
    }

    ws = new Ws()
    wsC = new WsC()
    u = new Utils()
    m = new Masks()
    ls = new LocalStorage().GetUserData();



    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }


    getDataMonth = async () => {



        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
            on a.id = ad.id_angajat where a.id = @p3  and isnull(a.inactiv,0) != 1  `, {
            p3: this.props.match.params.idAngajat
        })


        let _pontaje = this.ws.customSelect(`select * from pontaje where la_data = @p1 and isnull(sters,0) != 1`, {
            p1: this.state.dataStart
        })

        let _monitorAngajati = this.ws.customSelect(`select ml.process_name, ml.app_id, ml.app_name, ml.start_datetime, ml.end_datetime, ml.seconds_used, ml.details, ml.is_synced, ml.cand_received, ml.cand, ml.token_user, ml.id_user, ml.eticheta, m.icon,m.is_productive  from monitorizare_log_folosire ml left join monitorizare_aplicatii m on ml.process_name = m.process_name
        where Cast(ml.start_datetime as date) >= @p1 and Cast(ml.start_datetime as date) <= @p2 and isnull(m.sters,0) !=1 `, {
            p1: this.state.dataStartDistributiaT,
            p2: this.state.dataEndDistributiaT
        })



        let _aplicatiiAll = this.ws.customSelect(`select * from monitorizare_aplicatii where isnull(sters,0) != 1`, {
            p1: 1
        })


        let _program = this.ws.customSelect(`select * from program_lucru where id_angajat = @p1`, {
            p1: this.props.match.params.idAngajat
        })





        let [angajati, pontaje, monitorAngajati, aplicatiiAll, program] = await Promise.all([_angajati, _pontaje, _monitorAngajati, _aplicatiiAll, _program])


        console.log('angajati :>> ', angajati);
        console.log('pontaje :>> ', pontaje);
        console.log('monitorAngajati :>> ', monitorAngajati);

        if (angajati.Succes && pontaje.Succes && monitorAngajati.Succes && aplicatiiAll.Succes && program.Succes) {

            let ang = [...angajati.Content]
            let pont = [...pontaje.Content]
            let monitor = [...monitorAngajati.Content]
            let appAll = [...aplicatiiAll.Content]
            let prg = [...program.Content]

            // console.log('appScreenShots :>> ', appScreenShots);


            // console.log('appAll :>> ', appAll);
            console.log('monitor :>> ', monitorAngajati);






            // console.log('evaluari :>> ', evaluari);


            for (let i = 0, n = ang.length; i < n; i++) {



                let idxPontaje = pont.findIndex(pp => Number(pp.id_angajat) === Number(ang[i].id) && this.m.datesAreEgual(new Date(pp.la_data), new Date(this.state.dataAzi)))

                // console.log('idxPontaje :>> ', idxPontaje);

                if (idxPontaje !== -1) {

                    ang[i]['ora_pornire'] = pont[idxPontaje]['cand_inceput_ora'] || '08:00'


                } else {
                    ang[i]['ora_pornire'] = '08:00'
                }








            }

            let raportAplicatii = []

            // for (let i = 0, n = this.u.oreLucruDefault.length; i < n; i++) {

            //     for (let j = 0, m = monitor.length; j < m; j++) {
            //         // console.log('new Date(aa.start_datetime).getHours() :>> ', String(new Date(monitor[j].start_datetime).getHours()));
            //     }

            //     let filterAplicatii = monitor.filter(aa => (new Date(aa.start_datetime).getHours() > 10 ? String(new Date(aa.start_datetime).getHours()) : '0' + new Date(aa.start_datetime).getHours()) === this.u.oreLucruDefault[i].substring(0, 2))

            //     let objToPush = { name: this.u.oreLucruDefault[i], data: filterAplicatii }

            //     raportAplicatii.push(objToPush)
            // }

            // console.log('raportAplicatii :>> ', raportAplicatii);

            // const lengths = raportAplicatii.map(a => a.data.length);
            // let idx = lengths.indexOf(Math.max(...lengths));


            // let dataSetRaportAplicatii = []

            // for (let i = 0, n = raportAplicatii[idx].data.length; i < n; i++) {
            //     let objToPush = { label: i + '0', data: [], data_colors: [] }
            //     dataSetRaportAplicatii.push(objToPush)
            // }



            // for (let j = 0, m = raportAplicatii.length; j < m; j++) {

            //     for (let i = 0, n = dataSetRaportAplicatii.length; i < n; i++) {

            //         if (raportAplicatii[j].data[i]) {

            //             let minToPush = this.u.secondsToMinutesChart(raportAplicatii[j].data[i].seconds_used)

            //             // console.log('minToPush :>> ', minToPush);

            //             dataSetRaportAplicatii[i].data.push(minToPush)

            //             if (raportAplicatii[j].data[i]['is_productive'] === 1) {
            //                 dataSetRaportAplicatii[i]['data_colors'].push('blue')
            //             } else {

            //                 if (raportAplicatii[j].data[i]['app_id'] === "i0000000000000000000000000000000") {
            //                     dataSetRaportAplicatii[i]['data_colors'].push('gray')
            //                 } else {
            //                     dataSetRaportAplicatii[i]['data_colors'].push('red')
            //                 }

            //             }
            //         } else {
            //             dataSetRaportAplicatii[i].data.push(0)

            //             dataSetRaportAplicatii[i]['data_colors'].push('transparent')
            //         }




            //     }

            // }

            // console.log('dataSetRaportAplicatii :>> ', dataSetRaportAplicatii);

            // console.log('idx :>> ', idx);

            let intervalZile = this.m.jsDatesDifferenceInDays(this.state.dataStartDistributiaT, this.state.dataEndDistributiaT)

            console.log('intervalZILE :>> ', intervalZile);

            let pauza = this.u.returnPauzaInterval(prg, this.state.dataAzi, intervalZile)

            console.log('pauzaINTERVAL :>> ', pauza);


            ang = this.u.filterMonitorizareAngajati(ang, appAll, monitor, pauza)

            console.log('ang :>> ', ang);

            let oraSelectata = {}

            let oraAcum = new Date().getHours()

            if (this.state.oraSelectata === null) {
                oraSelectata = {
                    oraStart: `${oraAcum < 10 ? (`0${oraAcum}`) : (`${oraAcum}`)}`,
                    oraFinish: `${(oraAcum + 1) < 10 ? (`0${oraAcum + 1}`) : (`${oraAcum + 1}`)}`,
                }
            } else {
                oraSelectata = this.state.oraSelectata
            }


            let aplicatiIFolositeIntervalOre = ang[0].aplicatii_folosite_merged.filter(am => (this.u.ParseOraFromSql(am.start_datetime) >= oraSelectata.oraStart) && (this.u.ParseOraFromSql(am.start_datetime) <= oraSelectata.oraFinish))


            console.log('aplicatiIFolositeIntervalOre :>> ', aplicatiIFolositeIntervalOre);

            let _aplicatiiFolositeIntervalOre = []

            for (let j = 0, m = aplicatiIFolositeIntervalOre.length; j < m; j++) {

                let idx = _aplicatiiFolositeIntervalOre.findIndex(aF => aF.app_id === aplicatiIFolositeIntervalOre[j].app_id)



                if (idx !== -1) {
                    _aplicatiiFolositeIntervalOre[idx].seconds_used += aplicatiIFolositeIntervalOre[j].seconds_used
                    // console.log(' ang[i]aplicatii_folosite_merged :>> ', new Date(ang[i]['aplicatii_folosite_merged'][idx].start_datetime).getHours() ) ;
                } else {
                    _aplicatiiFolositeIntervalOre.push(aplicatiIFolositeIntervalOre[j])
                }

            }


            console.log('angMonth :>> ', ang);



            this.setState({
                angajatiMonth: ang.length > 0 ? ang[0] : {},
                // raportAplicatii: dataSetRaportAplicatii,
                loading: false,
                pauzaInterval: pauza
            })


        }


    }

    getData = async () => {


        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
            on a.id = ad.id_angajat where a.id = @p3  and isnull(a.inactiv,0) != 1  `, {
            p3: this.props.match.params.idAngajat
        })


        let _pontaje = this.ws.customSelect(`select * from pontaje where la_data = @p1 and isnull(sters,0) != 1`, {
            p1: this.state.dataStart
        })

        let _monitorAngajati = this.ws.customSelect(`select ml.process_name, ml.app_id, ml.app_name, ml.start_datetime, ml.end_datetime ,ml.seconds_used, ml.details, ml.is_synced, ml.cand_received, ml.cand, ml.token_user, ml.id_user, ml.eticheta, m.icon,m.is_productive from monitorizare_log_folosire ml left join monitorizare_aplicatii m on ml.process_name = m.process_name
        where Cast(start_datetime as date) = @p1 and isnull(m.sters, 0) != 1`, {
            p1: this.state.dataAzi
        })

//         let _evaluari = this.wsC.customSelect(`select e.*, a.poza, a.functie, a.nume as nume_user, (select count(*) from raspunsuri_head where id_evaluare = e.id and statusul = @p1) as completari_finalizate, 
//         (select count(*) from raspunsuri_head where id_evaluare = e.id ) as completari_toate, s.nume
// from evaluari e left join [${this.ls.InfoUser.Database}].[dbo].[angajati] a on a.id_user = e.id_user_aprobare
// left join sesiuni s on s.id = e.id_sesiune
// where a.id = @p2 and s.baza_date = @p3 and isnull(e.inactiv,0) != 1 ` , {
//             p1: 'Finalizat',
//             p2: this.props.match.params.idAngajat,
//             p3: this.ls.InfoUser.Database
//         })





//         let _optiuniRaspuns = this.wsC.customSelect(`select r.*, h.id_evaluare, h.statusul from raspunsuri_intrebari_raspunsuri r left join raspunsuri_head h on r.id_head = h.id 
//     order by r.id_optiune_raspuns asc`, {
//             p1: this.props.match.params.idsesiune,

//         })

        let _aplicatiiAll = this.ws.customSelect(`select * from monitorizare_aplicatii where isnull(sters,0) != 1`, {
            p1: 1
        })

        let _appScreenShots = this.ws.customSelect(`select s.operation_hash_id, s.file_name, s.cand, s.id_user, isnull(s.process_name,'?') as process_name , a.nume as nume_aplicatie

        from monitorizare_log_screenshots s
        left outer join monitorizare_aplicatii a on isnull(s.process_name,'?') = a.process_name
        
        where operation_hash_id in ( select operation_hash_id from monitorizare_log_folosire
                    where Cast(start_datetime as date) = @p1
                and id_user = ( select id_user from angajati where id = @p2 ) ) and isnull(a.sters,0) != 1  order by cand asc` , {
            p1: this.state.dataAzi,
            p2: this.props.match.params.idAngajat
        })


        let _program = this.ws.customSelect(`select * from program_lucru where id_angajat = @p1`, {
            p1: this.props.match.params.idAngajat
        })

        // let [angajati, pontaje, monitorAngajati, evalu, optiuniRaspuns, aplicatiiAll, appScreenShots, program] = await Promise.all([_angajati, _pontaje, _monitorAngajati, _evaluari, _optiuniRaspuns, _aplicatiiAll, _appScreenShots, _program])

        let [angajati, pontaje, monitorAngajati,  aplicatiiAll, appScreenShots, program] = await Promise.all([_angajati, _pontaje, _monitorAngajati, _aplicatiiAll, _appScreenShots, _program])


        // if (angajati.Succes && pontaje.Succes && monitorAngajati.Succes && evalu.Succes && optiuniRaspuns.Succes && aplicatiiAll.Succes && appScreenShots.Succes && program.Succes) {
        if (angajati.Succes && pontaje.Succes && monitorAngajati.Succes   && aplicatiiAll.Succes && appScreenShots.Succes && program.Succes) {


            let ang = [...angajati.Content]
            let pont = [...pontaje.Content]
            // let optiuniR = [...optiuniRaspuns.Content]
            let monitor = [...monitorAngajati.Content]
            let appAll = [...aplicatiiAll.Content]
            // let evaluari = [...evalu.Content]
            let screenShots = [...appScreenShots.Content]
            let prg = [...program.Content]

            console.log('program :>> ', program);
            // console.log('appScreenShots :>> ', appScreenShots);


            // console.log('appAll :>> ', appAll);
            // console.log('monitor :>> ', monitor);


            // let punctajMaxim = 0

            // punctajMaxim = optiuniR.reduce((a, r) => { return a + (r.puncte || 0) }, 0)

            // punctajMaxim = punctajMaxim / evaluari.length


            // for (let j = 0, m = evaluari.length; j < m; j++) {
            //     let pct = 0



            //     // console.log('punctajMaxim :>> ', punctajMaxim);

            //     // console.log('evaluari[j] :>> ', evaluari[j]);


            //     let filterR = optiuniR.filter(o => o.id_evaluare === evaluari[j].id)

            //     if (filterR.length > 0) {
            //         for (let k = 0, l = filterR.length; k < l; k++) {


            //             pct += filterR[k].raspuns ? filterR[k].puncte : 0 || 0
            //         }

            //         evaluari[j].puncte = pct
            //     } else {
            //         evaluari[j].puncte = pct
            //     }

            //     evaluari[j].procent_completare = Math.floor(((evaluari[j].completari_finalizate * 100) / evaluari[j].completari_toate) || 0)

            //     evaluari[j].color = evaluari[j].procent_completare >= 80 ? 'rgb(24 165 58)' : (evaluari[j].procent_completare < 80 && evaluari[j].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
            //     evaluari[j].color_puncte = evaluari[j].puncte >= (punctajMaxim - (punctajMaxim / 3)) ? 'rgb(24 165 58)' : (evaluari[j].puncte < (punctajMaxim - (punctajMaxim / 3)) && evaluari[j].puncte >= (punctajMaxim / 2) ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
            //     evaluari[j].checked = false
            //     evaluari[j].raspunsuri = filterR



            // }

            // console.log('evaluari :>> ', evaluari);


            for (let i = 0, n = ang.length; i < n; i++) {



                let idxPontaje = pont.findIndex(pp => Number(pp.id_angajat) === Number(ang[i].id) && this.m.datesAreEgual(new Date(pp.la_data), new Date(this.state.dataAzi)))

                // console.log('idxPontaje :>> ', idxPontaje);

                if (idxPontaje !== -1) {

                    ang[i]['ora_pornire'] = pont[idxPontaje]['cand_inceput_ora'] || '08:00'


                } else {
                    ang[i]['ora_pornire'] = '08:00'
                }







                // if (evaluari.length > 0) {

                //     // console.log('evaluari :>> ', evaluari);
                //     ang[i].puncte = evaluari.reduce((a, c) => {
                //         // console.log('a :>> ', a);
                //         // console.log('c.puncte :>> ', c.puncte);
                //         return a + c.puncte
                //     }, 0)
                // }


            }

            let raportAplicatii = []

            for (let i = 0, n = this.u.oreLucruDefault.length; i < n; i++) {

                for (let j = 0, m = monitor.length; j < m; j++) {
                    // console.log('new Date(aa.start_datetime).getHours() :>> ', String(new Date(monitor[j].start_datetime).getHours()));
                }

                let filterAplicatii = monitor.filter(aa => (new Date(aa.start_datetime).getHours() > 10 ? String(new Date(aa.start_datetime).getHours()) : '0' + new Date(aa.start_datetime).getHours()) === this.u.oreLucruDefault[i].substring(0, 2))

                let objToPush = { name: this.u.oreLucruDefault[i], data: filterAplicatii }

                raportAplicatii.push(objToPush)
            }

            // console.log('raportAplicatii :>> ', raportAplicatii);

            const lengths = raportAplicatii.map(a => a.data.length);
            let idx = lengths.indexOf(Math.max(...lengths));


            let dataSetRaportAplicatii = []

            for (let i = 0, n = raportAplicatii[idx].data.length; i < n; i++) {
                let objToPush = { label: i + '0', data: [], data_colors: [] }
                dataSetRaportAplicatii.push(objToPush)
            }



            for (let j = 0, m = raportAplicatii.length; j < m; j++) {

                for (let i = 0, n = dataSetRaportAplicatii.length; i < n; i++) {

                    if (raportAplicatii[j].data[i]) {

                        let minToPush = this.u.secondsToMinutesChart(raportAplicatii[j].data[i].seconds_used)

                        // console.log('minToPush :>> ', minToPush);

                        dataSetRaportAplicatii[i].data.push(minToPush)

                        if (raportAplicatii[j].data[i]['is_productive'] === 1) {
                            dataSetRaportAplicatii[i]['data_colors'].push('blue')
                        } else {

                            if (raportAplicatii[j].data[i]['app_id'] === "i0000000000000000000000000000000") {
                                dataSetRaportAplicatii[i]['data_colors'].push('gray')
                            } else {
                                dataSetRaportAplicatii[i]['data_colors'].push('red')
                            }

                        }
                    } else {
                        dataSetRaportAplicatii[i].data.push(0)

                        dataSetRaportAplicatii[i]['data_colors'].push('transparent')
                    }




                }

            }

            console.log('dataSetRaportAplicatii :>> ', dataSetRaportAplicatii);

            // console.log('idx :>> ', idx);

            let pauza = this.u.returnPauzaInterval(prg, this.state.dataAzi)


            ang = this.u.filterMonitorizareAngajati(ang, appAll, monitor, pauza)

            console.log('ang :>> ', ang);

            let oraSelectata = {}

            let oraAcum = new Date().getHours()

            if (this.state.oraSelectata === null) {
                oraSelectata = {
                    oraStart: `${oraAcum < 10 ? (`0${oraAcum}`) : (`${oraAcum}`)}`,
                    oraFinish: `${(oraAcum + 1) < 10 ? (`0${oraAcum + 1}`) : (`${oraAcum + 1}`)}`,
                }
            } else {
                oraSelectata = this.state.oraSelectata
            }


            let aplicatiIFolositeIntervalOre = ang[0].aplicatii_folosite_merged.filter(am => (this.u.ParseOraFromSql(am.start_datetime) >= oraSelectata.oraStart) && (this.u.ParseOraFromSql(am.start_datetime) <= oraSelectata.oraFinish))


            console.log('aplicatiIFolositeIntervalOre :>> ', aplicatiIFolositeIntervalOre);

            let aplicatiIFolositeIntervalOreClone = JSON.parse(JSON.stringify(aplicatiIFolositeIntervalOre))

            let _aplicatiiFolositeIntervalOre = []

            for (let j = 0, m = aplicatiIFolositeIntervalOreClone.length; j < m; j++) {

                let idx = _aplicatiiFolositeIntervalOre.findIndex(aF => aF.app_id === aplicatiIFolositeIntervalOreClone[j].app_id)



                if (idx !== -1) {
                    if (new Date(_aplicatiiFolositeIntervalOre[idx].start_datetime).getHours() === new Date(aplicatiIFolositeIntervalOreClone[j].start_datetime).getHours()) {
                        _aplicatiiFolositeIntervalOre[idx].seconds_used += aplicatiIFolositeIntervalOreClone[j].seconds_used
                    } else {
                        _aplicatiiFolositeIntervalOre.push(aplicatiIFolositeIntervalOreClone[j])
                    }
                    // console.log(' ang[i]aplicatii_folosite_merged :>> ', new Date(ang[i]['aplicatii_folosite_merged'][idx].start_datetime).getHours() ) ;
                } else {
                    _aplicatiiFolositeIntervalOre.push(aplicatiIFolositeIntervalOreClone[j])
                }

            }

            let sS = screenShots.filter(am => (this.u.ParseOraFromSql(am.cand) >= oraSelectata.oraStart) && (this.u.ParseOraFromSql(am.cand) <= oraSelectata.oraFinish))

            console.log('screenShots :>> ', screenShots);

            console.log('aplicatiiFolositeIntervalOre :>> ', aplicatiIFolositeIntervalOre);



            let aplicatiIFolositeIntervalOreDetails = ang[0].aplicatii_folosite_merged.filter(am => (this.u.ParseOraFromSql(am.start_datetime) >= oraSelectata.oraStart) && (this.u.ParseOraFromSql(am.start_datetime) <= oraSelectata.oraFinish))


            console.log('aplicatiIFolositeIntervalOreDetails :>> ', aplicatiIFolositeIntervalOreDetails);

            let ore = this.u.returnOreLucruInterval(prg, this.state.dataAzi)







            console.log('pauza :>> ', pauza);


            console.log('ang :>> ', ang);

            let angObj = ang.length > 0 ? ang[0] : {}

            let oraSelectataApp = {}

            if (this.state.oraSelectata === null) {
                let idxAppOraSelectata = angObj.productivity_hourly.findIndex(ph => ph.hour === oraAcum)

                if (idxAppOraSelectata !== -1) {
                    oraSelectataApp = angObj.productivity_hourly[idxAppOraSelectata]
                }
            } else {

                let oraSStart = this.state.oraSelectata.oraStart < 10 ? Number(this.state.oraSelectata.oraStart.substring(1)) : this.state.oraSelectata.oraStart

                console.log('oraSStart :>> ', oraSStart);

                let idxAppOraSelectata = angObj.productivity_hourly.findIndex(ph => ph.hour === Number(oraSStart))

                if (idxAppOraSelectata !== -1) {
                    oraSelectataApp = angObj.productivity_hourly[idxAppOraSelectata]
                }

            }




            console.log('oraSelectataApp :>> ', oraSelectataApp);


            console.log('ore :>> ', ore);

            this.setState({
                angajati: angObj,
                aplicatiiFolositeIntervalOre: _aplicatiiFolositeIntervalOre,
                aplicatiiFolositeIntervalOreDetails: aplicatiIFolositeIntervalOreDetails,
                oraSelectataApp: oraSelectataApp,
                screenShots: sS,
                raportAplicatii: dataSetRaportAplicatii,
                loading: false,
                oreLucruSelectie: ore,
                oraSelectata: oraSelectata,
                pauza: pauza
            })


        }
    }


    selectZi = (z) => {

        let dataStart = this.state.dataAzi




        dataStart = new Date(dataStart).setDate(z)
        dataStart = new Date(dataStart)

        // console.log('dataStart :>> ', dataStart);

        if (dataStart.getMonth() < new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataStart)
            let dataE = this.m.lastDayMonth(dataStart)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                dataStart: dataS,
                dataEnd: dataE,
                raportAplicatii: null,
                ziua: z,
                loading: true
            }, () => {
                this.getData()
            })
        } else {
            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                raportAplicatii: null,
                loading: true,
                ziua: z,

            }, () => {
                this.getData()
            })
        }

    }

    selectLuna = (l) => {
        let dataStart = this.state.dataAzi




        dataStart = new Date(dataStart).setMonth(l)
        dataStart = new Date(dataStart)

        // console.log('dataStart :>> ', dataStart);

        if (dataStart.getMonth() < new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataStart)
            let dataE = this.m.lastDayMonth(dataStart)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                dataStart: dataS,
                dataEnd: dataE,
                raportAplicatii: null,
                luna: l,
                zile: this.u.getAllDaysInMonth(dataStart.getFullYear(), dataStart.getMonth() + 1),
                ziua: 1,
                loading: true
            }, () => {
                this.getData()
            })
        } else {
            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                raportAplicatii: null,
                loading: true,
                luna: l,
                ziua: 1,
                zile: this.u.getAllDaysInMonth(dataStart.getFullYear(), dataStart.getMonth() + 1),

            }, () => {
                this.getData()
            })
        }
    }


    selectAnul = (a) => {
        let dataStart = this.state.dataAzi




        dataStart = new Date(dataStart).setFullYear(a)
        dataStart = new Date(dataStart)

        // console.log('dataStart :>> ', dataStart);

        if (dataStart.getMonth() < new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataStart)
            let dataE = this.m.lastDayMonth(dataStart)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                dataStart: dataS,
                dataEnd: dataE,
                raportAplicatii: null,
                anul: a,
                loading: true
            }, () => {
                this.getData()
            })
        } else {
            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                raportAplicatii: null,
                loading: true,
                anul: a,

            }, () => {
                this.getData()
            })
        }
    }


    dataStartChange = (ev) => {
        console.log('ev :>> ', ev);

        let dataStart = ev




        console.log('dataStart :>> ', dataStart);

        if (dataStart.getMonth() < new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataStart)
            let dataE = this.m.lastDayMonth(dataStart)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                dataStart: dataS,
                dataEnd: dataE,
                raportAplicatii: null,
                loading: true
            }, () => {
                this.getData()
            })
        } else {
            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                raportAplicatii: null,
                loading: true

            }, () => {
                this.getData()
            })
        }

        this.setState({

        })
    }


    dataPerioadaChange = (ev) => {

        console.log('ev :>> ', ev);
        let dataStart = ev[0]
        let dataFinish = ev[1]




        console.log('this.state.dataEndDistributiaT :>> ', this.state.dataEndDistributiaT);
        if (dataFinish) {
            this.setState({
                dataStartDistributiaT: dataStart,
                dataEndDistributiaT: dataFinish,
                raportAplicatii: null,
                loading: true
            }, () => {
                this.getDataMonth()
            })
        } else {
            this.setState({
                dataStartDistributiaT: dataStart,
                dataEndDistributiaT: dataFinish,

            })
        }






    }

    minusZi = () => {

        let dataStart = this.state.dataAzi




        dataStart = new Date(dataStart).setDate(new Date(dataStart).getDate() - 1)
        dataStart = new Date(dataStart)

        // console.log('dataStart :>> ', dataStart);

        if (dataStart.getMonth() < new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataStart)
            let dataE = this.m.lastDayMonth(dataStart)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                dataStart: dataS,
                dataEnd: dataE,
                raportAplicatii: null,
                loading: true
            }, () => {
                this.getData()
            })
        } else {
            this.setState({
                dataAzi: this.u.transformDataForSql(dataStart),
                raportAplicatii: null,
                loading: true

            }, () => {
                this.getData()
            })
        }


    }


    plusZi = () => {
        let dataEnd = this.state.dataAzi




        dataEnd = new Date(dataEnd).setDate(new Date(dataEnd).getDate() + 1)
        dataEnd = new Date(dataEnd)

        console.log('dataEnd :>> ', dataEnd);

        if (dataEnd.getMonth() > new Date(this.state.dataAzi).getMonth()) {
            let dataS = this.m.fistDayMonth(dataEnd)
            let dataE = this.m.lastDayMonth(dataEnd)

            this.setState({
                dataAzi: this.u.transformDataForSql(dataEnd),
                dataStart: dataS,
                dataEnd: dataE,
                raportAplicatii: null,
                loading: true
            }, () => {
                this.getData()
            })
        } else {
            this.setState({
                raportAplicatii: null,
                dataAzi: this.u.transformDataForSql(dataEnd),
                loading: true

            }, () => {
                this.getData()
            })
        }
    }




    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }

    goToPicture = (ss) => {
        window.open(`${this.ws.adresaMedia}/monitorizare/aplicatii/${this.state.angajati.id}/${ss.file_name}`)
    }

    openScreenshotProcess = (app) =>{ 


        console.log('app :>> ', app);

        let hourApp = new Date(app.start_datetime).getHours()
        let minuteApp = new Date(app.start_datetime).getMinutes()

        console.log('hourApp :>> ', hourApp);
        console.log('minuteApp :>> ', minuteApp);

        let idxScreenshot = this.state.screenShots.findIndex(scr => scr.process_name === app.process_name && new Date(scr.cand).getHours() === hourApp && new Date(scr.cand).getMinutes() === minuteApp)


        console.log('idxScreenshot :>> ', idxScreenshot);

        if(idxScreenshot !== -1){
            window.open(`${this.ws.adresaMedia}/monitorizare/aplicatii/${this.state.angajati.id}/${this.state.screenShots[idxScreenshot].file_name}`)
        }else{
            let idxScreenshot2 = this.state.screenShots.findIndex(scr => scr.process_name === app.process_name )

            console.log('idxScreenshot2 :>> ', idxScreenshot2);

            if(idxScreenshot2 !== -1){
                window.open(`${this.ws.adresaMedia}/monitorizare/aplicatii/${this.state.angajati.id}/${this.state.screenShots[idxScreenshot2].file_name}`)
            }

        }

    }


    openAplicatieAngajat = (app) => {
        console.log('app :>> ', app);

        this.setState({
            openPopupAplicatie: true,
            aplicatie: app
        })
    }


    scrollRight = (idx) => {
        let container = document.getElementById(idx);

        // console.log('container :', container);






        // console.log('container[i] :>> ', container[i]);
        let containerScroll = container.scrollLeft

        // console.log('containerScroll :>> ', containerScroll);

        container.scrollTo({
            top: 0,
            left: containerScroll + 250,
            behavior: 'smooth'
        })



    }

    scrollLeft = (idx) => {
        let container = document.getElementById(idx);

        // console.log('container :', container);



        let containerScroll = container.scrollLeft

        // console.log('containerScroll :>> ', containerScroll);

        container.scrollTo({
            top: 0,
            left: containerScroll - 250,
            behavior: 'smooth'
        })

    }

    changeOra = (o) => {


        console.log('o :>> ', o);

        let oraSelectata = {
            oraStart: `${o.hour < 10 ? (`0${o.hour}`) : (`${o.hour}`)}`,
            oraFinish: `${(o.hour + 1) < 10 ? (`0${o.hour + 1}`) : (`${o.hour + 1}`)}`,
        }

        console.log('oraSelectata :>> ', oraSelectata);

        this.setState({ oraSelectata: oraSelectata }, () => {
            this.getData()
        })
    }


    openTichet = (app) => {

        console.log('app :>> ', app);

        this.setState({
            openEticheta: true,
            aplicatieSelectata: app
        })
    }

    changeAplicatie = (ev) => {

        let n = ev.target.name
        let v = ev.target.value

        let objToChange = { ...this.state.aplicatieSelectata }

        objToChange[n] = v

        this.setState({ aplicatieSelectata: objToChange })
    }

    addEticheta = (etc) =>{ 
        let objToChange = { ...this.state.aplicatieSelectata }
        objToChange['eticheta'] = etc

        this.setState({aplicatieSelectata:objToChange})
    }

    salveazaAplicatie = async () => {


        let updateApp = await this.ws.update('monitorizare_log_folosire', { eticheta: this.state.aplicatieSelectata.eticheta }, { details: this.state.aplicatieSelectata.details })

        if (updateApp.Succes) {

            this.setState({
                aplicatieSelectata: {},
                openEticheta: false
            }, () => {

                this.getData()
                this.getDataMonth()
            })

        }
    }





    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }
                <Grid style={{ maxWidth: 1400, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.monitorizare.monitorizareAngajati} </h1>
                    </Grid>





                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll' }}>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ textAlign: 'left', paddingTop: 10, paddingLeft: 20, marginBottom: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <span style={{ fontWeight: 600, fontSize: 22 }}> {this.state.angajati.nume}   </span><br />
                                        <span className='pm-monitorizare-normal-text' style={{
                                            color: '#9a9a9a'
                                        }}>{this.state.angajati.functie}</span>
                                    </Grid>
                                    <Grid style={{ textAlign: 'right' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <div style={{ marginTop: 20, textAlign: 'right' }} className='monthcalendar-header'>
                                            <i onClick={this.minusZi} className='material-icons' style={{ verticalAlign: 'unset', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_left</i>
                                            <span style={{ fontSize: 16, verticalAlign: 'text-bottom', textTransform: 'uppercase' }} className='monthcalendar-title'>
                                                {new Date(this.state.dataAzi).getDate() < 10 ? '0' + new Date(this.state.dataAzi).getDate() : new Date(this.state.dataAzi).getDate()} {this.numeLuna(new Date(this.state.dataStart).getMonth() + 1)} {new Date(this.state.dataStart).getFullYear()}
                                                <div style={{ display: 'inline-block' }}>
                                                    <DatePicker

                                                        selected={new Date(this.state.dataAzi)}
                                                        onChange={this.dataStartChange}
                                                        startDate={new Date(this.state.dataAzi)}
                                                        shouldCloseOnSelect={true}
                                                        calendarClassName="calendar-left-absolute"
                                                        locale="ro"
                                                        dateFormat="dd/MM/yyyy"
                                                        customInput={<div className='pm-date-picker'>

                                                            <span>     <i style={{

                                                                fontSize: 18,
                                                                verticalAlign: 'middle'

                                                            }} className='material-icons'>today</i>




                                                                {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                            </span>


                                                        </div>}
                                                        monthsShown={1}
                                                        // popperClassName="some-custom-class"
                                                        popperPlacement="top-end"
                                                        popperModifiers={[
                                                            //   {
                                                            //     name: "offset",
                                                            //     options: {
                                                            //       offset: [5, 10],
                                                            //     },
                                                            //   },
                                                            {
                                                                // name: "preventOverflow",
                                                                options: {
                                                                    rootBoundary: "viewport",
                                                                    tether: false,
                                                                    altAxis: true,
                                                                },
                                                            },
                                                        ]}
                                                    />

                                                </div>

                                            </span>
                                            <i onClick={this.plusZi} className='material-icons' style={{ verticalAlign: 'unset', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_right</i>
                                        </div>
                                    </Grid>

                                </Grid>
                                <Divider style={{ marginTop: 10, marginBottom: 20, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                            </Grid>



                            {/* <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <Grid style={{ width: '90%', margin: 'auto', border: '1px solid gray' }} container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10 }} > ANI </h5>
                                                <Divider style={{ marginTop: 20, marginBottom: 20, backgroundColor: 'black' }} className="pm-divider" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid style={{
                                                    maxHeight: 300,
                                                    overflow: 'scroll',
                                                }} container>
                                                    {this.state.ani.map((a, idx) => {
                                                        return (
                                                            <Grid onClick={() => { this.selectAnul(a) }} style={{ backgroundColor: a === this.state.anul ? '#19a63c' : 'white', paddingTop: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <span style={{ color: a === this.state.anul ? 'white' : 'black' }} >{a}</span>
                                                                <Divider style={{ marginTop: 20 }} className="pm-divider" />
                                                            </Grid>
                                                        )

                                                    })}

                                                </Grid>

                                            </Grid>


                                        </Grid>

                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <Grid style={{ width: '90%', margin: 'auto', border: '1px solid gray' }} container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10 }} > LUNI </h5>
                                                <Divider style={{ marginTop: 20, marginBottom: 20, backgroundColor: 'black' }} className="pm-divider" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid style={{
                                                    maxHeight: 300,
                                                    overflow: 'scroll',
                                                }} container>
                                                    {this.state.luni.map((l, idx) => {
                                                        return (
                                                            <Grid onClick={() => { this.selectLuna(idx) }} style={{ backgroundColor: idx === this.state.luna ? '#19a63c' : 'white', paddingTop: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <span style={{ color: idx === this.state.luna ? 'white' : 'black' }} >{l}</span>
                                                                <Divider style={{ marginTop: 20 }} className="pm-divider" />
                                                            </Grid>
                                                        )

                                                    })}

                                                </Grid>

                                            </Grid>


                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <Grid style={{ width: '90%', margin: 'auto', border: '1px solid gray' }} container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10 }} > ZILE </h5>
                                                <Divider style={{ marginTop: 20, marginBottom: 20, backgroundColor: 'black' }} className="pm-divider" />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Grid style={{
                                                    maxHeight: 300,
                                                    overflow: 'scroll',
                                                }} container>
                                                    {this.state.zile.map((z, idx) => {
                                                        return (
                                                            <Grid onClick={() => { this.selectZi(z) }} style={{ backgroundColor: z === this.state.ziua ? '#19a63c' : 'white', paddingTop: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                <span style={{ color: z === this.state.ziua ? 'white' : 'black' }} > ZIUA {z}</span>
                                                                <Divider style={{ marginTop: 20 }} className="pm-divider" />
                                                            </Grid>
                                                        )

                                                    })}

                                                </Grid>

                                            </Grid>


                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid> */}

                            {/* <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                {this.state.oreLucruSelectie.map((o, idx) => {
                                    return (
                                        <Button key={idx}
                                            style={{ marginRight: 20, marginTop: 20 }}

                                            className={'add-button-green'} onClick={() => { this.changeOra(o) }}  >

                                            {o.oraStart} - {o.oraFinish}
                                        </Button>
                                    )
                                })}

                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10 }} > ORA {this.state.oraSelectata.oraStart} - {this.state.oraSelectata.oraFinish}</h5>

                            </Grid> */}


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container>
                                    <Grid style={{ marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6} >
                                        <Grid container>
                                            <Grid style={{ marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6} >
                                                <Grid container className='pm-monitor-container'>
                                                    <Grid style={{ backgroundColor: 'rgb(53	113	253)', textAling: 'center', padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'center', color: 'white', margin: 0, fontSize: 16 }} >

                                                            <span>{this.dictionary.monitorizare.distributiaTimpului}</span>
                                                            <div style={{ display: 'inline-block' }}>

                                                                <DatePicker

                                                                    selected={this.state.dataStartDistributiaT}
                                                                    onChange={this.dataPerioadaChange}
                                                                    startDate={this.state.dataStartDistributiaT}
                                                                    endDate={this.state.dataEndDistributiaT}
                                                                    selectsRange={true}
                                                                    // inline
                                                                    shouldCloseOnSelect={false}
                                                                    calendarClassName="calendar-left-absolute"
                                                                    locale="ro"
                                                                    dateFormat="dd/MM/yyyy"
                                                                    customInput={<div className='pm-date-picker'>

                                                                        <span>     <i style={{

                                                                            fontSize: 18,
                                                                            verticalAlign: 'middle'

                                                                        }} className='material-icons'>today</i>




                                                                            {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                                        </span>


                                                                    </div>}
                                                                    monthsShown={2}
                                                                // popperClassName="some-custom-class"
                                                                // popperPlacement="bottom-right"
                                                                // popperModifiers={[
                                                                //     //   {
                                                                //     //     name: "offset",
                                                                //     //     options: {
                                                                //     //       offset: [5, 10],
                                                                //     //     },
                                                                //     //   },
                                                                //     {
                                                                //         // name: "preventOverflow",
                                                                //         options: {
                                                                //             rootBoundary: "viewport",
                                                                //             tether: false,
                                                                //             altAxis: true,
                                                                //         },
                                                                //     },
                                                                // ]}
                                                                />
                                                            </div>

                                                        </h5>


                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500  }}>

                                                                            <ThumbUp style={{ width: 18, height: 18, }} />

                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpProductiv} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500, }}>    {this.u.secondsToHoursAndMinutes(this.state.angajatiMonth.timp_productiv)} </span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500    }}>

                                                                            <ThumbDown style={{ width: 18, height: 18 }} />
                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpNeproductiv} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(this.state.angajatiMonth.timp_neproductiv)}</span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500,  }}>
                                                                            <HistoryToggle style={{ width: 18, height: 18 }} />
                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpMort} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(this.state.angajatiMonth.idle)}</span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10, marginBottom: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500  }}>
                                                                            <SportSoccer style={{ width: 18, height: 18 }} />
                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500, }}> {this.dictionary.monitorizare.pauza} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500, }}>    {this.u.secondsToHoursAndMinutes(this.state.pauzaInterval.time * 60)}</span>
                                                            </Grid>


                                                        </Grid>

                                                    </Grid>

                                                    {this.state.angajatiMonth.aplicatii_folosite_principale.filter(app => app.is_productive === 1).length > 0 &&
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <Grid container>
                                                                <Divider style={{ marginTop: 10, backgroundColor: '#C8C8C8' }} className="pm-divider" />
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                                    <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10, marginTop: 0 }} > {this.dictionary.monitorizare.aplicatiiProductive}</h5>

                                                                </Grid>

                                                                <Grid  className='pm-monitor-container-scroll' style={{ height: 117, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    {this.state.angajatiMonth.aplicatii_folosite_principale.filter(app => app.is_productive === 1).map((app, idx) => {
                                                                        return (
                                                                            <Grid style={{ paddingTop: 5 }} key={idx} container>
                                                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                                    <div key={idx}>

                                                                                        <div
                                                                                            style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                                        >
                                                                                            <img

                                                                                                style={{ margin: 0, width: 24, height: 24 }}
                                                                                                src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                                                            />

                                                                                        </div>

                                                                                        <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.app_name.length > 100 ? app.app_name.substring(0, 90) + '...' : app.app_name}</span><br />

                                                                                    </div>
                                                                                </Grid>

                                                                                <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                                </Grid>

                                                                                {idx < this.state.angajatiMonth.aplicatii_folosite_principale.filter(app => app.is_productive === 1).length - 1 &&
                                                                                    <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                                }

                                                                            </Grid>
                                                                        )
                                                                    })}


                                                                </Grid>
                                                            </Grid>

                                                        </Grid>
                                                    }


                                                    {this.state.angajatiMonth.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).length > 0 &&

                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <Grid container>
                                                                <Divider style={{ marginTop: 10, backgroundColor: '#C8C8C8' }} className="pm-divider" />
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10, marginTop: 0 }} > {this.dictionary.monitorizare.aplicatiiNeproductive}</h5>

                                                                </Grid>

                                                                <Grid  className='pm-monitor-container-scroll' style={{ height: 117, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    {this.state.angajatiMonth.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).map((app, idx) => {
                                                                        return (
                                                                            <Grid style={{ paddingTop: 5 }} key={idx} container>
                                                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                                    <div key={idx}>

                                                                                        <div
                                                                                            style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                                        >
                                                                                            <img

                                                                                                style={{ margin: 0, width: 24, height: 24 }}
                                                                                                src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                                                            />

                                                                                        </div>

                                                                                        <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.app_name.length > 100 ? app.app_name.substring(0, 90) + '...' : app.app_name}</span><br />

                                                                                    </div>
                                                                                </Grid>

                                                                                <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                                </Grid>

                                                                                {idx < this.state.angajatiMonth.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).length - 1 &&
                                                                                    <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                                }
                                                                            </Grid>
                                                                        )
                                                                    })}


                                                                </Grid>
                                                            </Grid>

                                                        </Grid>

                                                    }

                                                    {this.state.angajatiMonth.etichete.length > 0 &&

                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <Grid container>
                                                                <Divider style={{ marginTop: 10, backgroundColor: '#C8C8C8' }} className="pm-divider" />
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10, marginTop: 0 }} > {this.dictionary.monitorizare.eticheteFolosite}</h5>

                                                                </Grid>

                                                                <Grid  className='pm-monitor-container-scroll' style={{ height: 117, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    {this.state.angajatiMonth.etichete.map((app, idx) => {
                                                                        return (
                                                                            <Grid style={{ paddingTop: 5 }} key={idx} container>
                                                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                                    <div style={{ paddingLeft: 10 }} key={idx}>



                                                                                        <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.eticheta}</span><br />

                                                                                    </div>
                                                                                </Grid>

                                                                                <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                                </Grid>

                                                                                {idx < this.state.angajatiMonth.etichete.length - 1 &&
                                                                                    <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                                }
                                                                            </Grid>
                                                                        )
                                                                    })}


                                                                </Grid>
                                                            </Grid>

                                                        </Grid>

                                                    }


                                                </Grid>
                                            </Grid>
                                            <Grid style={{ marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6} >
                                                <Grid container className='pm-monitor-container' >

                                                    <Grid style={{ backgroundColor: 'rgb(53	113	253)', textAling: 'center', padding: 16, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'center', color: 'white', margin: 0, fontSize: 16 }} >
                                                            {this.dictionary.monitorizare.ora}              {this.state.oraSelectata && this.state.oraSelectata.oraStart} - {this.state.oraSelectata && this.state.oraSelectata.oraFinish}
                                                        </h5>
                                                    </Grid>

                                                    <Grid className='pm-monitor-container-scroll' style={{ height: 640, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                        {this.state.aplicatiiFolositeIntervalOreDetails.map((app, idx) => {

                                                            return (
                                                                <Grid style={{ paddingTop: 10 }} key={idx} container>
                                                                    <Grid style={{ textAlign: 'left' }} item xs={8} sm={8} md={8} lg={8} xl={8}>

                                                                        <div key={idx}>

                                                                            <div
                                                                                style={{ display: 'inline-block', marginRight: 8, marginLeft: 8, verticalAlign: 'super' }}
                                                                            >
                                                                                <div style={{ display: 'inline-block', width: 16, height: 16, backgroundColor: app.is_productive === 1 ? 'rgb(25 174 62' : 'rgb(252	14	34	)', borderRadius: '50%' }}></div>

                                                                            </div>
                                                                            <div style={{ display: 'inline-block', width: '80%' }}>
                                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500, display: 'block',wordBreak: 'break-all' }}>
                                                                                    {app.eticheta &&
                                                                                        <span style={{ verticalAlign: 'middle' }}>
                                                                                            <BookmarksBlack onClick={() => { this.openTichet(app) }} style={{ width: 14, height: 14 }} />
                                                                                        </span>

                                                                                    }
                                                                                    {app.eticheta && `${app.eticheta} - `}    {app.details.length > 30 ? app.details.substring(0, 90) + '...' : app.details}</span>

                                                                                <span className="pm-monitorizare-light-text" style={{ fontWeight: 400, display: 'block', color: '#b3b3b3' }}>    {this.u.ParseOraFromSql(app.start_datetime)} -  {this.u.ParseOraFromSql(app.end_datetime)}</span>


                                                                            </div>


                                                                        </div>
                                                                    </Grid>

                                                                    <Grid style={{ textAlign: 'right', paddingRight: 3 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                                        <div>
                                                                            {!app.eticheta &&
                                                                                <span style={{ verticalAlign: 'middle' }}>
                                                                                    <BookmarksBlack onClick={() => { this.openTichet(app) }} style={{ width: 14, height: 14 }} />
                                                                                </span>



                                                                            }

                                                                            <span style={{ verticalAlign: 'middle' }}>
                                                                                <OpenInNew onClick={()=>{this.openScreenshotProcess(app)}} style={{ width: 14, height: 14 }} />
                                                                            </span>


                                                                            <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                        </div>

                                                                    </Grid>

                                                                    {idx < this.state.aplicatiiFolositeIntervalOreDetails.length - 1 &&
                                                                        <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                    }
                                                                </Grid>
                                                            )

                                                        })}

                                                        {this.state.aplicatiiFolositeIntervalOreDetails.length === 0 &&
                                                            <Grid style={{ textAling: 'center', padding: 16, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'center', margin: 0, fontSize: 16 }} >
                                                                    {this.dictionary.monitorizare.nuExistaDatePentruOra}
                                                                </h5>
                                                            </Grid>
                                                        }

                                                    </Grid>
                                                </Grid>


                                            </Grid>

                                        </Grid>

                                    </Grid>

                                    <Grid style={{ marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6} >




                                        <ClientAppointment

                                            oreLucru={this.state.oreLucruSelectie}
                                            oraSelectata={this.state.oraSelectata}
                                            appsUsed={this.changeOra}
                                            pauza={this.state.pauza}
                                            appsToday={this.state.angajati.productivity_hourly}
                                            aplicatiiFolositeIntervalOre={this.state.oraSelectataApp}
                                            appList={

                                                this.state.aplicatiiFolositeIntervalOre.length > 0 &&
                                                <Grid style={{
                                                    width: '33%', margin: 'auto',
                                                    boxShadow: '2px 2px 7px 0px rgb(226 224 224)',
                                                    WebkitBoxShadow: '2px 2px 7px 0px rgb(226 224 224)',
                                                    overflow: 'hidden',
                                                    marginTop: 81,
                                                    marginLeft: 96,
                                                    borderRadius: 5,

                                                }} container>
                                                    <Grid style={{ backgroundColor: 'rgb(53	113	253)', textAling: 'center', padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'center', color: 'white', margin: 0, fontSize: 16 }} > {this.dictionary.monitorizare.aplicatii}</h5>


                                                    </Grid>




                                                    <Grid  className='pm-monitor-container-scroll' style={{

                                                        overflow: 'scroll',
                                                        height: 357
                                                    }} item xs={12} sm={12} md={12} lg={12} xl={12} >






                                                        {this.state.aplicatiiFolositeIntervalOre.map((app, idx) => {

                                                            return (
                                                                <Grid style={{ paddingTop: 10 }} key={idx} container>
                                                                    <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                        <div key={idx}>

                                                                            <div
                                                                                style={{ display: 'inline-block', marginRight: 8, marginLeft: 8, verticalAlign: 'middle' }}
                                                                            >
                                                                                <div style={{ display: 'inline-block', width: 16, height: 16, backgroundColor: app.is_productive === 1 ? 'rgb(25 174 62' : 'rgb(252	14	34	)', borderRadius: '50%' }}></div>

                                                                            </div>

                                                                            <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.app_name.length > 100 ? app.app_name.substring(0, 90) + '...' : app.app_name}</span><br />

                                                                        </div>
                                                                    </Grid>

                                                                    <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                        <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                    </Grid>

                                                                    {idx < this.state.aplicatiiFolositeIntervalOre.length - 1 &&
                                                                        <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                    }
                                                                </Grid>
                                                            )

                                                        })}
                                                    </Grid>
                                                </Grid>}
                                        />






                                    </Grid>

                                </Grid>

                            </Grid>




                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10 }} > {this.dictionary.monitorizare.screenshots}</h5>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div className='pm-angajat-screenshots' id='pm-angajat-screenshot' style={{ overflowX: 'scroll' }}>
                                            {this.state.screenShots.map((ss, idx) => {
                                                return (
                                                    <div onClick={() => { this.goToPicture(ss) }} style={{ display: 'table-cell', padding: 20, cursor: 'pointer' }} key={idx}>
                                                        <img style={{
                                                            width: 300,
                                                            height: 200,

                                                        }}
                                                            src={`${this.ws.adresaMedia}/monitorizare/aplicatii/${this.state.angajati.id}/${ss.file_name}`} />

                                                        <span style={{ fontWeight: 500, fontSize: 14, display: 'block' }}> 
                                                        
                                                        {ss.nume_aplicatie ? ss.nume_aplicatie : `[${ss.process_name}]`}
                                                        
                                                         {ss.file_name} - {this.u.ParseOraFromSql(ss.cand)}   </span>

                                                    </div>
                                                )
                                            })}



                                        </div>




                                    </Grid>

                                    {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span onClick={() => { this.scrollLeft('pm-angajat-screenshot') }} style={{ cursor: 'pointer' }}>

                                                <i className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_left</i>
                                                Scroll Stanga
                                            </span>

                                            <span onClick={() => { this.scrollRight('pm-angajat-screenshot') }} style={{ cursor: 'pointer' }}>
                                                Scroll Dreapta
                                                <i onClick={this.minusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_right</i>
                                            </span>
                                        </div>
                                    </Grid> */}






                                    <Grid style={{ padding: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        {/* <div style={{
                                            display: 'flex',
                                            width: '100%',
                                            justifyContent: 'space-between'
                                        }}>
                                            {this.state.oreLucru.map((o, idx) => {
                                                return (
                                                    <div key={idx} >
                                                        <span style={{ fontWeight: 500, fontSize: 14 }}>  {o}   </span>

                                                    </div>
                                                )
                                            })}

                                        </div> */}

                                        {this.state.oraSelectata &&
                                            <div style={{
                                                display: 'flex',
                                                width: '100%',
                                                justifyContent: 'space-between'
                                            }}>


                                                <div  >
                                                    <span style={{ fontWeight: 500, fontSize: 14 }}>  {this.state.oraSelectata.oraStart}   </span>

                                                </div>

                                                <div  >
                                                    <span style={{ fontWeight: 500, fontSize: 14 }}>  {this.state.oraSelectata.oraFinish}   </span>

                                                </div>

                                            </div>
                                        }




                                    </Grid>
                                </Grid>

                            </Grid>


                        </Grid>
                    </Grid>
                </Grid>


                <PopUpAplicatie
                    open={this.state.openPopupAplicatie}
                    dialogClose={() => { this.setState({ openPopupAplicatie: false }) }}
                    angajat={this.state.angajati}
                    aplicatie={this.state.aplicatie}
                />

                <EditEticheta
                    open={this.state.openEticheta}
                    dialogClose={() => { this.setState({ openEticheta: false }) }}
                    aplicatie={this.state.aplicatieSelectata}
                    changeAplicatie={this.changeAplicatie}
                    salveazaAplicatie={this.salveazaAplicatie}
                    eticheteAll={this.state.angajatiMonth.etichete}
                    addEticheta={this.addEticheta}
                />
            </div >
        );
    }
}